import * as actionCatalog from '@wix/auto_sdk_automations_action-catalog';
import * as activationActionLog from '@wix/auto_sdk_automations_activation-action-log';
import * as activationLog from '@wix/auto_sdk_automations_activation-log';
import * as activationActionSummary from '@wix/auto_sdk_automations_activation-action-summary';
import * as storageItem from '@wix/auto_sdk_automations_storage-item';
import * as triggerCatalog from '@wix/auto_sdk_automations_trigger-catalog';
import * as automationsService from '@wix/auto_sdk_automations_automations-service';
import * as customTrigger from '@wix/auto_sdk_automations_custom-trigger';
import * as activations from '@wix/auto_sdk_automations_activations';
import * as automationsV2 from '@wix/auto_sdk_automations_automations-v-2';
import * as automationTemplates from '@wix/auto_sdk_automations_automation-templates';

export {
  actionCatalog,
  activationActionLog,
  activationLog,
  activationActionSummary,
  storageItem,
  triggerCatalog,
  automationsService,
  customTrigger,
  activations,
  automationsV2,
  automationTemplates,
};
